export function linear(t) {
  return +t;
}



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-ease/src/linear.js
// module id = ../../../../d3-ease/src/linear.js
// module chunks = 4